@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

.info-tooltip {
  height: 30px;
  width: 30px;
  padding: 5px;

  svg {
    height: 100%;
    width: 100%;
    color: @settings-page--stores-selected-checkout-info--text-color;
  }
}
